import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

function dm_c_12_cards() {
  const sections = document.querySelectorAll('.c-12-cards, section.c-12-cards');

  sections.forEach((section) => {
    const viewport = section.querySelector('.cards-swiper');
    if (!viewport) return;

    // ensure swiper structure (be tolerant if markup changes)
    let wrapper = viewport.querySelector('.swiper-wrapper');
    const cardEls = Array.from(viewport.querySelectorAll('.card'));
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      // wrap existing card elements as slides
      cardEls.forEach((card) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(card.cloneNode(true));
        wrapper.appendChild(slide);
      });
      viewport.replaceChildren(wrapper);
    } else {
      // ensure slides have proper class
      const slides = wrapper.querySelectorAll('.swiper-slide');
      if (!slides.length) {
        Array.from(wrapper.children).forEach((child) => child.classList.add('swiper-slide'));
      }
    }

    // ensure pagination element exists
    let paginationEl = viewport.querySelector('.swiper-pagination');
    if (!paginationEl) {
      paginationEl = document.createElement('div');
      paginationEl.className = 'swiper-pagination';
      viewport.appendChild(paginationEl);
    }

    // breakpoint: enable swiper under lg (max-width: 991.98px)
    const mq = '(max-width: 991.98px)';
    let swiperInstance = null;
    let resizeTimer = null;
    let lastIsActive = window.matchMedia(mq).matches;

    function initSwiper() {
      if (swiperInstance) return;
      if (!window.matchMedia(mq).matches) return;

      const config = {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 400,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          // tablet >=768 and <992 => 2 slides
          768: { slidesPerView: 2 },
        },
      };

      try {
        swiperInstance = new Swiper(viewport, config);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('c-12 Swiper init failed:', err);
        swiperInstance = null;
      }
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      try {
        swiperInstance.destroy(true, true);
      } catch (err) {
        // ignore
      }
      swiperInstance = null;
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const isActive = window.matchMedia(mq).matches;
        if (isActive === lastIsActive) return;
        lastIsActive = isActive;
        if (isActive) initSwiper();
        else destroySwiper();
      }, 120);
    }

    // initial
    if (window.matchMedia(mq).matches) initSwiper();
    window.addEventListener('resize', onResize);

    // cleanup if section removed
    const mo = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        destroySwiper();
        window.removeEventListener('resize', onResize);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
}

export { dm_c_12_cards };